// Shown while AuthProvider is checking for an existing Supabase session.
// Renders briefly on every page load — keep it tiny and on-brand.

export default function LoadingScreen({ label = 'Loading…' }) {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[var(--g-bg)]">
      <div className="inline-block animate-spin rounded-full h-8 w-8 border-2 border-[var(--g-primary)] border-t-transparent" />
      <p className="mt-4 text-sm text-[var(--g-text-2)]">{label}</p>
    </div>
  );
}
